module.exports = __webpack_public_path__ + "img/9791188547098.5f251a7e.jpg";